import React from 'react';

function MyFooter () {
    return (
        <footer className="footer py-4  ">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-lg-between">
            <div className="col-lg-6 mb-lg-0 mb-4">
              <div className="copyright text-center text-sm text-muted text-lg-start">
                © {(new Date().getFullYear())},
                {(" built for a better life by ")}
                <a href="https://www.autom8sustain.com" className="font-weight-bold" target="_blank">Autom8Sustain</a>
              </div>
            </div>
            <div className="col-lg-6">
              <ul className="nav nav-footer justify-content-center justify-content-lg-end">
                <li className="nav-item">
                  <a href="https://www.autom8sustain.com" className="nav-link text-muted" target="_blank">Autom8Sustain</a>
                </li>
                <li className="nav-item">
                  <a href="https://www.autom8sustain.com/about.html" className="nav-link text-muted" target="_blank">About Us</a>
                </li>
                <li className="nav-item">
                  <a href="https://www.autom8sustain.com/blog" className="nav-link text-muted" target="_blank">Blog</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    )
}

export default MyFooter;